import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit';
import React from 'react';

interface State {
  title?: string;
  icon?: React.ReactNode;
}

const initialState: State = {
  title: '',
  icon: undefined,
};

type CR<T> = CaseReducer<State, PayloadAction<T>>;

const setPageTitleCR: CR<{
  title?: string;
}> = (state, action) => ({
  ...state,
  title: action.payload.title,
});

const setPageIconCR: CR<{
  icon?: React.ReactNode;
}> = (state, action) => ({
  ...state,
  icon: action.payload.icon,
});

const slice = createSlice({
  name: 'pageTitle',
  initialState,
  reducers: {
    setPageTitle: setPageTitleCR,
    setPageIcon: setPageIconCR,
  },
});

export const { setPageTitle, setPageIcon } = slice.actions;
export default slice.reducer;
